export default __webpack_public_path__ + "static/media/error-outline-icon.3b99a15d.svg";